export default __webpack_public_path__ + "static/media/more.c8d44414.svg";